const ProfessionalHeadshots = () => {
  return (
    <>
      <div>ProfessionalHeadshots</div>
    </>
  )
}

export default ProfessionalHeadshots
